export const DASHBOARD_CODE = 'dashboard';

// PAGE TITLE
export const TITLE_PREFIX = 'Dashboard';

// ROUTES
export const DASHBOARD_PATH = '/:path(|dashboard)';
export const DASHBOARD_ROUTE = '/dashboard';
